import { getInstance } from '../getInstance/getInstance';
export const DEFAULT_MODAL_DIMENSIONS = {
  height: 380,
  width: 580
};
export const PREVIEW_MODAL_DIMENSIONS = {
  height: 600,
  width: 600
};
export async function openModal(_ref) {
  let {
    appParams,
    wixCodeApi,
    modalType,
    serviceType,
    dimensions,
    referralInfo,
    isDayful
  } = _ref;
  const baseUrl = 'https://bookings.wixapps.net/_api/bookings-viewer';
  const modalUrl = `${baseUrl}/viewer-modals`;
  const referralInfoParam = referralInfo ? `&referralInfo=${referralInfo}` : ``;
  const deviceType = wixCodeApi.window.formFactor;
  return wixCodeApi.window.openModal(`${modalUrl}?deviceType=${deviceType}&instance=${getInstance({
    appParams,
    wixCodeApi
  })}&locale=${wixCodeApi.site.language}&modal=${modalType}&serviceType=${serviceType}${referralInfoParam}${isDayful ? '&dayful=sch' : ''}`, {
    ...dimensions,
    theme: 'BARE'
  });
}
//# sourceMappingURL=openModal.js.map